"use client"

// components
import Tag from "@/shared/Tag";

// helpers
import { useDimension } from "../../hooks/useDimensions";
import useStorage from "@/hooks/useStorage";

// assets
import styles from "@/assets/styles/components/hirer-mobile-banner.module.scss";


const HirerMobileBanner = () => {
  const [width] = useDimension();
  const isMobile = width < 720;

  const [hideHirerMobileTag, setHideHirerMobileTag, isLocalStorageLoading] = useStorage("local", "hideHirerMobileTag");

  const showTag = isLocalStorageLoading ? false : hideHirerMobileTag !== "true";

  const handleCloseTag = () => {
    setHideHirerMobileTag("true");
  };

  // renders
  if (!isMobile || !showTag) {
    return null;
  }

  return (
    <Tag
      color="gray"
      className={styles["locl-hirer-mobile-banner"]}
      onClose={handleCloseTag}
      closable
    >
      Please visit our site using a desktop browser for an optimized experience.
    </Tag>
  );
};

export default HirerMobileBanner;
